// extracted by mini-css-extract-plugin
module.exports = {"MarketingBanner_wrapper":"marketingBanner_MarketingBanner_wrapper__ItT6x","tag":"marketingBanner_tag__0RAEz","cta":"marketingBanner_cta__wjnil"};